/* PML currency switcher — display-only conversion of INR prices using
   Shopify's legacy rates feed (/services/javascripts/currencies.js).
   Checkout always settles in the store currency (INR). */
(function () {
  var SYMBOLS = { USD: '$', EUR: '€', AUD: 'A$', GBP: '£', INR: 'Rs.' };
  var STORAGE_KEY = 'pml-currency';
  var BASE = 'INR';
  var PRICE_SELECTOR = '.price-item, .price__container .price-item, .cart-item__price-wrapper .price, .totals__total-value';
  var MONEY_RE = /Rs\.?\s?([\d,]+(?:\.\d+)?)/;

  function rates() {
    return window.Currency && window.Currency.rates ? window.Currency.rates : null;
  }

  function convert(amount, to) {
    var r = rates();
    if (!r || !r[BASE] || !r[to]) return null;
    return (amount * r[BASE]) / r[to];
  }

  function formatMoney(amount, code) {
    var opts = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    return SYMBOLS[code] + amount.toLocaleString('en-US', opts);
  }

  function applyTo(el, code) {
    if (!el.dataset.pmlInr) {
      var m = el.textContent.match(MONEY_RE);
      if (!m) return;
      el.dataset.pmlInr = m[1].replace(/,/g, '');
      el.dataset.pmlOriginal = el.textContent.trim();
    }
    if (code === BASE) {
      el.textContent = el.dataset.pmlOriginal;
      return;
    }
    var converted = convert(parseFloat(el.dataset.pmlInr), code);
    if (converted === null) return;
    el.textContent = formatMoney(converted, code) + ' ';
  }

  function applyAll(code) {
    document.querySelectorAll(PRICE_SELECTOR).forEach(function (el) {
      applyTo(el, code);
    });
    document.querySelectorAll('[data-pml-currency-current]').forEach(function (el) {
      el.textContent = code;
    });
    document.querySelectorAll('[data-pml-currency-option]').forEach(function (a) {
      a.classList.toggle('pml-currency__option--active', a.dataset.pmlCurrencyOption === code);
    });
  }

  function current() {
    try {
      return localStorage.getItem(STORAGE_KEY) || BASE;
    } catch (e) {
      return BASE;
    }
  }

  function set(code) {
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch (e) {
      /* private mode */
    }
    applyAll(code);
  }

  function init() {
    document.querySelectorAll('[data-pml-currency-option]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        set(a.dataset.pmlCurrencyOption);
        var details = a.closest('details');
        if (details) details.removeAttribute('open');
      });
    });
    var saved = current();
    if (saved !== BASE) applyAll(saved);
    else applyAll(BASE);

    // re-apply after Dawn re-renders sections (variant changes, cart updates)
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        var c = current();
        if (c !== BASE) applyAll(c);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
